export default __webpack_public_path__ + "static/media/google-map.77ea674e.svg";